module.exports = __webpack_public_path__ + "img/team-1.57c3faaa.png";